// src/store/index.js
import { create } from 'zustand';
import ApartmentService from './../service/ApartmentService';
import HouseService from './../service/HouseService';

// Apartments store
export const useApartments = create((set) => ({
    apartments: [],
    setApartments: async () => {
        try {
            const fromStore = localStorage.getItem('apartments');
            if (fromStore) {
                set({ apartments: JSON.parse(fromStore) });
                // ali u pozadini ipak osvježi podatke
                const { getApartments } = ApartmentService();
                getApartments((res) => res.data).then((response) => {
                    set({ apartments: response.data });
                    localStorage.setItem('apartments', JSON.stringify(response.data));
                });
            } else {
                const { getApartments } = ApartmentService();
                const response = await getApartments((res) => res.data);
                set({ apartments: response.data });
                localStorage.setItem('apartments', JSON.stringify(response.data));
            }
        } catch (error) {
            console.error('Greška pri dohvatanju apartmana:', error);
        }
    },
    setAfterUpdateServer: async () => {
        try {
            const { getApartments } = ApartmentService();
            const response = await getApartments((res) => res.data);
            set({ apartments: response.data });
            localStorage.setItem('apartments', JSON.stringify(response.data));
        } catch (error) {
            console.error('Greška pri dohvatanju apartmana:', error);
        }
    }
}));

// Statusi rezervacija store
export const useBookingStatus = create((set) => ({
    bookingStatus: [
        { label: 'Čeka potvrdu', value: 'pending' },
        { label: 'Potvrđeno', value: 'confirmed' },
        { label: 'Otkazano', value: 'cancelled' }
    ]
}));

// Houses store
export const useHouses = create((set) => ({
    houses: [],
    setHouses: async () => {
        try {
            const fromStore = localStorage.getItem('houses');
            if (fromStore) {
                set({ houses: JSON.parse(fromStore) });
                // ali u pozadini ipak osvježi podatke
                const { getHouses } = HouseService();
                getHouses((res) => res.data).then((response) => {
                    set({ houses: response.data });
                    localStorage.setItem('houses', JSON.stringify(response.data));
                });
            } else {
                const { getHouses } = HouseService();
                const response = await getHouses((res) => res.data);
                set({ houses: response.data });
                localStorage.setItem('houses', JSON.stringify(response.data));
            }
        } catch (error) {
            console.error('Greška pri dohvatanju vila:', error);
        }
    },
    setAfterUpdateServer: async () => {
        try {
            const { getHouses } = HouseService();
            const response = await getHouses((res) => res.data);
            set({ houses: response.data });
            localStorage.setItem('houses', JSON.stringify(response.data));
        } catch (error) {
            console.error('Greška pri dohvatanju vila:', error);
        }
    }
}));
